module.exports = __webpack_public_path__ + "img/23.4d999929.jpg";